import { translateInComponent, translate } from 'infras/i18n';
import translations from './i18n.json';
import styled from '@emotion/styled';
import Link from 'presentations/views/components/atoms/Link';
import Icon from 'presentations/views/components/atoms/Icon';
import IconButton from 'presentations/views/components/atoms/IconButton';
import {
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import {
  blueGrayPale,
  gray02,
  gray04,
  primary,
} from 'presentations/views/styles/color';
import Transition from 'presentations/views/components/atoms/Transition';
import Checkbox from 'presentations/views/components/atoms/Checkbox';
import { useSummarizeSettingView } from './hooks';
import { helpPath } from 'presentations/routes/path';
import { AssistantUserSettingItem } from 'integrations/assistant/presentations/api/schema/assistant_user_setting';

interface Props {
  setting: AssistantUserSettingItem;
  onClose: () => void;
}

export default function Component(props: Props) {
  const { state, actions } = useSummarizeSettingView({
    setting: props.setting,
  });
  const t = translateInComponent([translations]);

  return (
    <Transition name="fade" in>
      <SettingContainer>
        <Header>
          <HeaderLeftItem>
            <HeaderLeftItemIconButton onClick={props.onClose}>
              <HeaderLeftItemIcon name="chevron-left" />
            </HeaderLeftItemIconButton>
            <HeaderTitle>
              <Title>{t('Settings')}</Title>
            </HeaderTitle>
          </HeaderLeftItem>
          <HelpIconContainer href={helpPath('todo')} target="_blank">
            <HelpIcon name="help" size={fontSize(16)} />
          </HelpIconContainer>
        </Header>
        <SettingForm>
          <SettingDescription>
            {t('Setting Summary Description')}
          </SettingDescription>
          <CheckboxContainer>
            <Checkbox
              isChecked={state.isSummaryEventDetail}
              label={t('isSummaryEventDetail')}
              name="isSummaryEventDetail"
              onChange={actions.onChangeSetting}
            />
          </CheckboxContainer>
          <CheckboxContainer>
            <Checkbox
              isChecked={state.isSummaryEventCount}
              label={t('isSummaryEventCount')}
              name="isSummaryEventCount"
              onChange={actions.onChangeSetting}
            />
          </CheckboxContainer>
          <CheckboxContainer>
            <Checkbox
              isChecked={state.isSummaryDuration}
              label={t('isSummaryDuration')}
              name="isSummaryDuration"
              onChange={actions.onChangeSetting}
            />
          </CheckboxContainer>
          {/* <CheckboxContainer>
            <Checkbox
              isChecked={state.isSummaryStartTravelTime}
              label={t('isSummaryStartTravelTime')}
              name="isSummaryStartTravelTime"
              onChange={actions.onChangeSetting}
            />
          </CheckboxContainer> */}
          {/* <CheckboxContainer>
            <Checkbox
              isChecked={state.isSummaryTravelType}
              label={t('isSummaryTravelType')}
              name="isSummaryTravelType"
              onChange={actions.onChangeSetting}
            />
          </CheckboxContainer>
          <CheckboxContainer>
            <Checkbox
              isChecked={state.isSummaryTravelTime}
              label={t('isSummaryTravelTime')}
              name="isSummaryTravelTime"
              onChange={actions.onChangeSetting}
            />
          </CheckboxContainer> */}
          {/* <CheckboxContainer>
            <Checkbox
              isChecked={state.isSummaryWeather}
              label={t('isSummaryWeather')}
              name="isSummaryWeather"
              onChange={actions.onChangeSetting}
            />
          </CheckboxContainer>
          <CheckboxContainer>
            <Checkbox
              isChecked={state.isSummaryTemperature}
              label={t('isSummaryTemperature')}
              name="isSummaryTemperature"
              onChange={actions.onChangeSetting}
            />
          </CheckboxContainer> */}
          <CheckboxContainer>
            <Checkbox
              isChecked={state.isSummaryReschedule}
              label={t('isSummaryReschedule')}
              name="isSummaryReschedule"
              onChange={actions.onChangeSetting}
            />
          </CheckboxContainer>
        </SettingForm>
      </SettingContainer>
    </Transition>
  );
}

const SettingContainer = styled.div``;

const Header = styled.div`
  padding: ${spacing(16)} ${spacing(12)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${gray04};
`;
const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;
const HeaderLeftItem = styled.div`
  display: flex;
  justify-content: flex-start;
`;
const HeaderLeftItemIconButton = styled(IconButton)`
  padding: ${spacing(4)};
  margin-right: ${spacing(8)};
`;
const HeaderLeftItemIcon = styled(Icon)`
  color: ${primary};
`;
const Title = styled.div`
  font-size: ${fontSize(20)};
  font-weight: ${fontWeight('bold')};
`;

const HelpIconContainer = styled(Link)`
  position: relative;
  top: 4px;
`;

const HelpIcon = styled(Icon)`
  width: 18px !important;
  height: 18px !important;
  color: ${gray02};
  ${mediaMax.tablet} {
    width: 18px !important;
    height: 18px !important;
  }
`;

const SettingForm = styled.div`
  overflow-y: auto;
  padding: ${spacing(16)} ${spacing(12)};
  background-color: ${blueGrayPale};
  height: calc(100vh / 2);
  ${mediaMax.tablet} {
    height: 400px;
  }
`;
const CheckboxContainer = styled.div`
  display: flex;
`;

const SettingDescription = styled.div`
  margin-bottom: ${spacing(16)};
`;
